import type { Vertex } from "./isometric";

// Normalized [0, 1]² footprints of the configurator's demo Grand Hotel.
export const HOTEL_OUTLINE: Vertex[] = [
  [0.0, 0.3983],
  [0.0614, 0.0],
  [0.344, 0.157],
  [0.3754, 0.3907],
  [0.429, 0.4562],
  [0.4161, 0.3466],
  [0.7997, 0.2943],
  [0.8004, 0.4787],
  [0.9558, 0.4134],
  [1.0, 0.787],
  [0.4933, 1.0],
  [0.4817, 0.9015],
  [0.4277, 0.92],
];

const LOBBY_ROOMS: Record<string, Vertex[]> = {
  reception: [
    [0.3754, 0.3908],
    [0.3014, 0.5179],
    [0.4602, 0.7063],
    [0.4817, 0.9015],
    [0.4277, 0.92],
    [0.0, 0.3965],
    [0.0614, 0.0],
    [0.344, 0.157],
  ],
  lounge: [
    [0.4161, 0.3466],
    [0.5814, 0.324],
    [0.6028, 0.5618],
    [0.5379, 0.5891],
    [0.429, 0.4562],
  ],
  bar: [
    [0.7997, 0.2943],
    [0.8004, 0.4787],
    [0.6028, 0.5618],
    [0.5814, 0.324],
  ],
  restaurant: [
    [0.6028, 0.9546],
    [0.5682, 0.6532],
    [0.9653, 0.4936],
    [1.0, 0.7869],
  ],
};

const GUEST_ROOMS: Record<string, Vertex[]> = {
  "01": [
    [1.0, 0.7869],
    [0.8954, 0.8309],
    [0.8608, 0.5378],
    [0.9654, 0.4939],
  ],
  "02": [
    [0.7922, 0.8746],
    [0.7576, 0.5816],
    [0.8608, 0.5378],
    [0.8954, 0.8309],
  ],
  "03": [
    [0.7004, 0.9129],
    [0.6657, 0.6199],
    [0.7576, 0.5816],
    [0.7922, 0.8746],
  ],
  "04": [
    [0.6037, 0.9536],
    [0.5691, 0.6605],
    [0.6657, 0.6199],
    [0.7004, 0.9129],
  ],
  "05": [
    [0.5691, 0.6605],
    [0.6037, 0.9536],
    [0.4933, 1.0],
    [0.4602, 0.7063],
  ],
  "06": [
    [0.3136, 0.4074],
    [0.3917, 0.5026],
    [0.295, 0.7579],
    [0.217, 0.6627],
  ],
  "07": [
    [0.2408, 0.3186],
    [0.3136, 0.4074],
    [0.217, 0.6628],
    [0.1441, 0.5739],
  ],
  "08": [
    [0.168, 0.2297],
    [0.2408, 0.3186],
    [0.1441, 0.5739],
    [0.0713, 0.4851],
  ],
  "09": [
    [0.0714, 0.4853],
    [0.0, 0.3965],
    [0.0485, 0.0841],
    [0.168, 0.23],
  ],
  "10": [
    [0.4161, 0.3466],
    [0.5814, 0.324],
    [0.6028, 0.5618],
    [0.5379, 0.5891],
    [0.429, 0.4562],
  ],
  "11": [
    [0.5814, 0.324],
    [0.6989, 0.3081],
    [0.7072, 0.5179],
    [0.6028, 0.5618],
  ],
  "12": [
    [0.7997, 0.2943],
    [0.8004, 0.4787],
    [0.7072, 0.5179],
    [0.6989, 0.3081],
  ],
};

/** Ground floor first. */
export const HOTEL_FLOORS = [
  toFloor("lobby", LOBBY_ROOMS),
  toFloor("1", GUEST_ROOMS),
  toFloor("2", GUEST_ROOMS),
];

// Upper plates hide the rooms below, so only the top floor is interactive.
export const TOP_FLOOR_ROOM_IDS = HOTEL_FLOORS[
  HOTEL_FLOORS.length - 1
].rooms.map((room) => room.id);

function toFloor(id: string, rooms: Record<string, Vertex[]>) {
  return {
    id,
    rooms: Object.entries(rooms).map(([slot, outline]) => ({
      id: `${id}-${slot}`,
      outline,
    })),
  };
}
